import { post, postData } from './http'
import global from '@/api/global'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
// }
var name = global.commonName
var namev2 = global.commonNameV2
var signature = global.signature
var crmServer = global.crmServer
var crmServer3 = global.crmServer3
// 消息管理选择用户列表
// export const systemListTree = p => post(`/${crmServer}/s/busisystem/systemListTree`, p)
export let systemListTree = p => {
  if (localStorage.getItem('isCutCrm3') == 1) {
    return post(`${crmServer3}/sBusiness/systemListTree`, p)
  } else {
    return post(`/${crmServer}/s/busisystem/systemListTree`, p)
  }
}
// 用户信息
export const loginUser = p => post(`/${name}/user/loginUser`, p)
// 用户信息
export const loginUserV2 = p => post(`/${namev2}/user/loginUser`, p)
// 菜单tree
// export const rightTree = p => post(`/${name}/user/rightTree`, p)
// 省市县下拉
export const bAreasList = p => post(`/${signature}/api/bAreasList`, p)
// 省市县下拉名字查询
export const findAreas = p => post(`/${signature}/api/findAreas`, p)
// 消息管理新建
export const cMessageAdd = p => post(`/${signature}/cMessage/add`, p)
// 消息管理编辑
export const cMessageUpdate = p => post(`/${signature}/cMessage/update`, p)
// 消息管理列表
export const cMessageList = p => post(`/${signature}/cMessage/list`, p)
// 用户对象list
export const cMessageRelList = p => post(`/${signature}/cMessage/relList`, p)
// 消息管理删除
export const cMessageDelete = p => post(`/${signature}/cMessage/delete`, p)
// 消息管理发布/撤回
export const updateStatus = p => post(`/${signature}/cMessage/updateStatus`, p)
// 消息未读数量
export const receiveMsgNoReadSum = p => post(`/${signature}/cMessage/receiveMsgNoReadSum`, p)
// 消息通知
export const receiveMsgNoReadList = p => post(`/${signature}/cMessage/receiveMsgNoReadList`, p)
// 读消息
export const readMsg = p => post(`/${signature}/cMessage/readMsg `, p)
// 消息通知(标题)
export const receiveMsgList = p => post(`/${signature}/cMessage/receiveMsgList`, p)
// 司机app 上传apk版本列表
export const appInfoList = p => post(signature + '/app/info/list', p)
// 司机app上传apk保存
export const upload = p => post(signature + '/app/info/upload', p)
// App所属系统
export const groupDropDownBox = p => post(signature + '/app/info/groupDropDownBox', p)
// App修改是否强制更新
export const updateAppInfo = p => post(signature + '/app/info/updateAppInfo', p)
// App版本设置-删除
export const deleteAppInfo = id => post(signature + `/app/info/deleteAppInfo/${id}`)
// 查询货主信用分-常艳
export const accountCreditScore = p => post(signature + '/api/credit/accountCreditScore', p)
// 查询货主信用分列表-常艳
export const creditScoreDetail = p => post(signature + '/api/credit/creditScoreDetail', p)
